function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 21a9 9 0 01-9-9 9 9 0 019-9 9 9 0 019 9 9 9 0 01-9 9z",
  fill: "#2F80ED"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.436 15.894l5.421-5.423a1.082 1.082 0 00-1.529-1.53L10.672 13.6l-2.45-2.451a1.082 1.082 0 00-1.53 1.53l3.216 3.215a1.077 1.077 0 001.53 0z",
  fill: "#fff"
});

var SvgIconStatusDoneBlue24 = function SvgIconStatusDoneBlue24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDIxQzcuMDI5MyAyMSAzIDE2Ljk3MDcgMyAxMkMzIDcuMDI5MyA3LjAyOTMgMyAxMiAzQzE2Ljk3MDcgMyAyMSA3LjAyOTMgMjEgMTJDMjEgMTYuOTcwNyAxNi45NzA3IDIxIDEyIDIxWiIgZmlsbD0iIzJGODBFRCIvPgo8cGF0aCBkPSJNMTEuNDM2MSAxNS44OTRMMTYuODU3NCAxMC40NzA4QzE3LjI4MTQgMTAuMDQ4NCAxNy4yODAzIDkuMzYzNzQgMTYuODU3NCA4Ljk0MTM3QzE2LjQzNjIgOC41MTk1NCAxNS43NTA0IDguNTE5NTQgMTUuMzI4NiA4Ljk0MTM3TDEwLjY3MTQgMTMuNTk5OUw4LjIyMTEgMTEuMTQ4OUM3Ljc5ODc1IDEwLjcyNzEgNy4xMTM1OCAxMC43MjcxIDYuNjkxNzYgMTEuMTQ4OUM2LjI2OTQxIDExLjU3MTMgNi4yNjk0MSAxMi4yNTcgNi42OTE3NiAxMi42NzgzTDkuOTA2NzMgMTUuODk0QzEwLjExODIgMTYuMTA1NCAxMC4zOTQ1IDE2LjIxMDkgMTAuNjcxNCAxNi4yMTA5QzEwLjk0ODMgMTYuMjEwOSAxMS4yMjQ2IDE2LjEwNTQgMTEuNDM2MSAxNS44OTRaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgIconStatusDoneBlue24 as ReactComponent };